/* eslint-disable eqeqeq */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from "react";
import { useSelector } from "react-redux";
import "./storeList.scss";
import { Skeleton } from "@material-ui/lab";

import FreezScreen from "../FreezScreen";
import { RootState } from "../../store/reducers";
import { useNavigate } from "react-router-dom";
import { get_lang } from "../../helper/getLang";

const StoreList = () => {
  const appState = useSelector((state: RootState) => state.appReducer);
  const state = useSelector((state: RootState) => state.apiReducer);
  const { storeInfo, bookingDetails } = state;
  const [isLoading] = useState(false);
  const navigate = useNavigate();
  const [routeLoading, setRouteLoading] = useState(false);
console.log(bookingDetails,'bookingDetails')
  const handleClick = (id: number) => {
    setRouteLoading(true);
    // Navigate to a different route
    navigate(`step-1?bId=${id}`);
  };

  return (
    <div id="wrapperStoreList">
      {isLoading ? (
        <div className="kanwar row m-0 mb-4 mt-3 d-flex flex-row">
          <div className="col-6"> <Skeleton height={50} /> </div>
          <div className="col-10"> <Skeleton height={50} /> </div>
          <div className="col-3"> <Skeleton height={50} /> </div>
        </div>
      ) : (
        <React.Fragment>
          {routeLoading && <FreezScreen />}
          <div
            id="StoreListMain"
            className={`px-3 ${
              appState?.langValue === "ar"
                ? `directionRt classForArabicReOrderMain`
                : ""
            } ${appState?.langValue == "ar" ? "arabicFamilyParent" : ""}`}
          >
            <div className="my-4"></div>
            {bookingDetails?.length > 0 ? (
              bookingDetails.map((item: any, i: any) => (
                <div
                  key={i}
                  onClick={() => handleClick(item?.id)}
                  className={`row mb-3 ${
                    appState?.langValue === "ar" ? "pr-2 pl-3" : "pr-3 pl-2"
                  } cursor-pointer`}
                >
                  <div className={`owl_item black col-12 px-0`}>
                    <a className="cursor-pointer">
                      
                      <span className="card-item">
                        <section id={`Products`}>
                          <div id={`category_`} className="w-100">
                            <div className={`inner_prod`}>
                              <span>
                                <div
                                  className={`prdCard d-flex  ${
                                    appState?.langValue === "ar"
                                      ? "align-items-end"
                                      : "align-items-end"
                                  }`}
                                  style={{
                                    background: `linear-gradient(90deg, rgba(0, 0, 0, 0.67) 0%, rgba(0, 0, 0, 0.19) 100%), url(${
                                      item?.image != null
                                        ? `${item?.image}`
                                        : `${storeInfo?.cover}`
                                    }) center center / cover no-repeat`,
                                  }}
                                >
                                  <div
                                    className={`mb-4 ms-4 ${
                                      appState?.langValue === "ar"
                                        ? `storeNameArabic`
                                        : `storeName`
                                    }`}
                                  >
                                    <h1
                                      className={`reOrderheading primary-text familysora700 textOver px-3 m-0 ${
                                        appState?.langValue === "ar"
                                          ? "text-right"
                                          : "text-left"
                                      }`}
                                    >
                                      
                                      {get_lang(
                                        item?.title,
                                        appState?.langValue
                                      )}
                                    </h1>
                                    <h2
                                      className={`reOrderheading my-3 textOver familysora400 px-3 m-0 ${
                                        appState?.langValue === "ar"
                                          ? "text-right"
                                          : "text-left"
                                      }`}
                                    >
                                      {get_lang(
                                        item?.description,
                                        appState?.langValue
                                      )}
                                    </h2>
                                    <h3
                                      className={`reOrderheading textOver familysora400 px-3 m-0 ${
                                        appState?.langValue === "ar"
                                          ? "text-right"
                                          : "text-left"
                                      }`}
                                    >
                                      {item?.slotsType == 2 ? `Starting From` : ''}
                                      {item?.price != 0 && item?.price != null ? ` ${item?.price}
                                      ${get_lang(
                                        storeInfo.storeCurrency,
                                        appState?.langValue
                                      )}  
                                       ${item?.slotsType   == 2 ? "" : "(Per Person)"} 
                                      ` : '' }{" "}
                                      
                                      
                                    </h3>
                                  </div>
                                </div>
                              </span>
                            </div>
                          </div>
                        </section>
                      </span>
                    </a>
                  </div>
                </div>
              ))
            ) : (
              <div
                className={`row mb-3 ${
                  appState?.langValue === "ar" ? "pr-2 pl-3" : "pr-3 pl-2"
                }`}
              >
                <div className={`owl_item black col-12 px-0`}>
                  <h3>Categories are not available !</h3>
                </div>
              </div>
            )}
          </div>
        </React.Fragment>
      )}
    </div>
  );
};

export default StoreList;
